<template>
  <v-container
    :style="'padding: 0; margin: 0;width: 100%;'"
    fill-height
    fluid
    wrap
  >
    <v-layout>
      <v-flex xs12>
        <v-card
          v-show="exportando_dados"
          :max-height="heightCard"
          :style="(exportando_dados)?'overflow: auto; background-color: #E1E1E1':'overflow: auto;'"
          class="mb-3"
        >
          <v-layout
            v-if="exportando_dados"
            :style="{'height': heightCard}"
            column
            fill-height
            justify-center
            align-center
          >
            <img
              :style="{'height': '200px'}"
              src="assets/videos/brcorte_caw.gif" >
              <!--
                  <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                >
                </v-progress-circular>-->
          </v-layout>
        </v-card>
        <v-flex
          v-show="!exportando_dados"
          xs12>
          <v-card-title>
            <h2>{{ strings[idioma].relatorios }} Logs</h2>
            <v-spacer/>

            <v-text-field
              v-model="search"
              :label="strings[idioma].pesquisar"
              append-icon="mdi-magnify"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="dataWeb"
            :search="search"

          >
            <template v-slot:items="props">
              <td>
                <strong>{{ props.item.id }}</strong>
              </td>
              <td>
                <strong>{{ (props.item.user !== null && props.item.user.NOME) ? props.item.user.NOME : '' }}</strong>
              </td>
              <td>
                <strong>{{ (props.item.user !== null && props.item.user.email) ? props.item.user.email : '' }}</strong>
              </td>
              <td>
                <strong>{{ moment(props.item.created_at).format(strings[idioma].formato_datas_com_hora) }}</strong>
              </td>
              <td>
                <strong>{{ props.item.ip }}</strong>
              </td>
              <td>
                <strong>{{ props.item.dispositivo }}</strong>
              </td>
              <td>
                <strong>{{ (props.item.acao > 0) ? acaoOrdem[props.item.acao - 1] : acaoOrdem[Math.abs(props.item.acao) - 1] + ' com falha.' }}</strong>
              </td>
              <td>
                <strong>{{ props.item.oid_alvo }}</strong>
              </td>
              <td>
                <strong>{{ props.item.mensagem }}</strong>
              </td>

            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="mdi-warning">
              Sua pesquisa por "{{ search }}" não encontrou resultados.
            </v-alert>
          </v-data-table>
          <template>
            <div
              v-if="pagination.totalItems > pagination.rowsPerPage"
              class="text-xs-center">
              <v-layout
                align-start
                justify-space-around
                wrap
                justify-center
                center>
                <v-flex md12>
                  <v-pagination
                    v-model="pagination.page"
                    :length="Math.ceil(pagination.totalItems / pagination.rowsPerPage)"
                    :total-visible="Math.ceil(pagination.totalItems / pagination.rowsPerPage) < pagination.rowsPerPage + 2 ? Math.ceil(pagination.totalItems / pagination.rowsPerPage) : pagination.rowsPerPage + 2"
                    circle/>
                </v-flex>

              </v-layout>
            </div>
          </template>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      logs: [],
      totalItems: [5, 10, 15, 20, 25],
      pagination: {
        rowsPerPage: 5,
        sortBy: null,
        descending: false,
        page: 1,
        totalItems: 0
      },
      search: '',
      columns: [],
      headers: [],
      dataExcel: [],
      dataWeb: [],
      acaoOrdem: [
        'Inseriu',
        'Editou',
        'Listou',
        'Deletou'
      ],
      exportando_dados: false
    }
  },
  computed: {
    ...mapState('app', ['idioma', 'headersComposicaoRacao', 'strings']),
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 150) + 'px'
    },
    widthCard () {
      return String(this.$vuetify.breakpoint.width - 300) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 50) + 'px; overflow: auto;'
    }
  },
  created () {
    // this.$store.commit('setDietasServer', this.user.data)
    this.exportando_dados = true
    this.axios.post('logs/getLogs', {}).then((res) => {
      this.logs = res.data
      this.dataAdapter()
      this.exportando_dados = false
    })
  },
  methods: {
    moment (...args) {
      return moment(...args)
    },
    dataAdapter () {
      let header = []
      let data = []
      let data2 = []
      let number = []
      const strings = this.strings
      let h = {
        id: ['#', '#'],
        user_NOME: ['Dono', 'Owner'],
        user_email: ['E-Mail', 'email'],
        created_at: ['Data de Modificação', 'Updated Date'],
        ip: ['IP', 'IP Address'],
        dispositivo: ['Dispositivo', 'Platform'],
        acao: ['Ação', 'Action'],
        oid_alvo: ['Tabela com ID', 'Table with ID'],
        mensagem: ['Mensagem', 'Message']
      }
      let rfHeader = this.relatorioFinanceiroEstrutura
      for (let rfI in rfHeader) {
        for (let rf in rfHeader[rfI]) {
          h[rf] = rfHeader[rfI][rf].title
          number.push(rf)
        }
      }
      let date = ['time']
      number = [...number]
      for (let i in h) {
        const aux = {
          text: h[i][this.idioma],
          align: 'left',
          sortable: true,
          value: i,
          label: h[i][this.idioma],
          field: i
        }
        header.push(aux)
      }
      // adaptar as dietas carregadas;
      for (let log of this.logs) {
        data2.push(log)
      }
      this.headers = header
      this.dataWeb = data2
      this.dataExcel = data
    }
  }
}
</script>
